/**
 * Hand-written tables marked `className="stack"` turn into labelled cards on phones (see app.css). The labels come
 * from the table's own header cells, so nothing has to be repeated on every <td>. Watches the page so rows added
 * later (a new line item, a dialog opening) are labelled too.
 */
const text = (el: Element) => (el.textContent ?? '').replace(/\s+/g, ' ').trim();

export function labelStackTables(root: ParentNode = document) {
  root.querySelectorAll<HTMLTableElement>('table.stack').forEach((table) => {
    const heads = [...(table.tHead?.rows[0]?.cells ?? [])].map(text);
    if (!heads.length) return;
    table.querySelectorAll<HTMLTableRowElement>('tbody tr').forEach((tr) => {
      const cells = [...tr.cells];
      // a row with merged or missing cells (an "empty" message, a note) has no clean column-to-header mapping
      if (cells.length !== heads.length) return;
      cells.forEach((td, i) => {
        if (heads[i] && td.dataset.label !== heads[i]) td.dataset.label = heads[i];
      });
    });
  });
}

export function watchStackTables(): () => void {
  if (typeof MutationObserver === 'undefined') return () => undefined;
  let queued = 0;
  const run = () => {
    queued = 0;
    labelStackTables();
  };
  const obs = new MutationObserver(() => {
    if (!queued) queued = requestAnimationFrame(run);
  });
  obs.observe(document.body, { childList: true, subtree: true });
  labelStackTables();
  return () => {
    obs.disconnect();
    if (queued) cancelAnimationFrame(queued);
  };
}
